const currentDate = (setToZeroHours?: boolean) => {
  const current = new Date();
  if (setToZeroHours) current.setUTCHours(0, 0, 0, 0);
  const year = current.getFullYear();
  const month = current.getMonth();
  const day = current.getDate();
  return {
    date: current,
    day,
    month,
    year,
  };
};

export default currentDate;
